import { useKeywordsCampaignsContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContext";
import { isCampaignCollecting } from "app/pages/digital-marketing/keywords-campaigns/shared/utils/isCampaignCollecting";

export const useIsCampaignCollecting = (): boolean => {
    const context = useKeywordsCampaignsContext();
    return isCampaignCollecting(context?.currentCampaignConfiguration);
};
